import React, { useState } from 'react';
import HeaderComponent from '../../Shared/components/HeaderComponent';
import ListadoUsuarioLayout from './ListadoUsuarioLayout';
import ModalFormUsuario from "./../modals/ModalFormUsuario";
import useCustomNavigate from '../../../hooks/useCustomNavigate';
import { PlusOutlined } from '@ant-design/icons';
import { Breadcrumb, Layout, Button } from 'antd';
const { Content } = Layout;

const UsuarioLayout = () => {

    const navigate = useCustomNavigate();
    const [openDialogUser, setDialogUser] = useState(false);
    const [action, setAction] = useState("create");
    const [userData, setUserData] = useState();

    {/** FUNCTIONS MODAL FORM USER **/ }
    const cancelDialogUser = () => {
        setUserData();
        setAction("create");
        setDialogUser(false);
    }
    const reloadData = () => {
        //setUserData();
        setAction("create");
        return true
    };
    const EditUser = (idUser) => {
        setUserData(idUser);
        setAction("update");
        setDialogUser(true);
    }

    return (
        <>
            <Layout>
                <Content>
                    <Breadcrumb
                        className='breadcrumb'
                        items={[
                            { title: <a href="/home">Inicio</a> },
                            { title: "Usuarios" }
                        ]}
                    />
                    <HeaderComponent title="Usuarios" />
                    <div className='w-full flex flex-end'>
                        <Button type="primary" shape="round"
                            className='mb-15'
                            onClick={() => setDialogUser(true)}
                        >
                            <PlusOutlined /> Nuevo usuario
                        </Button>
                    </div>

                    <ListadoUsuarioLayout
                        reloadData={reloadData}
                        EditUser={EditUser}
                    >
                    </ListadoUsuarioLayout>

                </Content>

                {/** INIT MODAL FORM PROFILE **/}
                <ModalFormUsuario
                    action={action}
                    userData={userData}
                    openDialogUser={openDialogUser}
                    cancelDialogUser={cancelDialogUser}
                    reloadData={reloadData}
                />
                {/** END MODAL FORM PROFILE **/}
            </Layout>
        </>
    )
}

export default UsuarioLayout;